import { Navigate, Outlet, RouteObject } from "react-router-dom";
import { PermissionedRoutes } from "../PermissionedRoutes";
import { PersonaContextProvider } from "./PersonaContext";

const PersonasLayout = () => (
  <PersonaContextProvider>
    <Outlet />
  </PersonaContextProvider>
);

export const PERSONAS_ROUTES: RouteObject[] = [
  {
    element: <PersonasLayout />,
    children: [
      { index: true, element: <Navigate to="list" replace /> },
      {
        path: "list",
        async lazy() {
          const { default: ListPersonas } = await import("./list/ListPersonas");
          return { element: <ListPersonas /> };
        },
      },
      {
        element: <PermissionedRoutes requiredPermissions={["indigo.add_persona"]} />,
        children: [
          {
            path: "create",
            async lazy() {
              const { default: CreatePersona } = await import("./modify/CreatePersona");
              return { element: <CreatePersona /> };
            },
          },
        ],
      },
      {
        element: <PermissionedRoutes requiredPermissions={["indigo.change_persona"]} />,
        children: [
          {
            path: "edit/:id",
            async lazy() {
              const { default: EditPersona } = await import("./modify/EditPersona");
              return { element: <EditPersona /> };
            },
          },
        ],
      },
    ],
  },
];
